import { Controller } from "@hotwired/stimulus"

// Dynamically loads blueprints based on selected collection
export default class extends Controller {
  static targets = ["blueprintSelect"]
  static values = {
    url: { type: String, default: "/content/select/blueprints" }
  }

  connect() {
    // Store original options if needed
    this.originalOptions = this.blueprintSelectTarget.innerHTML
  }

  async updateBlueprints(event) {
    const collectionId = event.target.value
    const blueprintSelect = this.blueprintSelectTarget

    if (!collectionId) {
      // Reset to empty state
      blueprintSelect.innerHTML = '<option value="">Select a blueprint...</option>'
      return
    }

    try {
      const response = await fetch(`${this.urlValue}?collection_id=${collectionId}`, {
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      if (!response.ok) throw new Error("Failed to fetch blueprints")

      const blueprints = await response.json()

      // Rebuild options
      blueprintSelect.innerHTML = '<option value="">Select a blueprint...</option>'
      blueprints.forEach(blueprint => {
        const option = document.createElement("option")
        option.value = blueprint.id
        option.textContent = blueprint.title
        blueprintSelect.appendChild(option)
      })
    } catch (error) {
      console.error("Error loading blueprints:", error)
    }
  }
}
